import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';

import { WorkflowActionPage } from './workflow-action.page';
import { SquadCastComponentsModule } from '../../components/squadcast.components.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild([
      {
        path: '',
        component: WorkflowActionPage,
      },
    ]),
    SquadCastComponentsModule,
  ],
  declarations: [WorkflowActionPage],
})
export class WorkflowActionPageModule {}
